import { useEffect, useState } from 'react'

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // agregar un event listener cunado el componente se monta
    window.addEventListener('resize', handleResize)

    // sacamos el event listener cuando el componente se desmonta para evitar memory leaks
    return () => window.removeEventListener('resize', handleResize)
  }, []) // dependencia vacia para que solo se ejecute una vez cuando se monta y desmonta el componente

  return windowSize
}

export default useWindowSize
